import { isSingleSignOnUser } from '../helpers/LocalStorage';

export const SET_SIGN_ON_TYPE = '@loa:SET_SIGN_ON_TYPE';

export function setSignOnType() {
	return {
		type: SET_SIGN_ON_TYPE,
		payload: isSingleSignOnUser(),
	};
}
